export default (api) => ({
  fetch: (params) => api.$get("/audit", { params }),

  fetchOne: (uuid) => api.$get(`/audit/${uuid}`),

  preparecsv: (params) => api.$get("/audit/preparecsv", { params }),
});
